export default "__VITE_ASSET__D14YJ1Qb__"